export const OPEN_MODAL = 'ui/OPEN_MODAL';
export const CLOSE_MODAL = 'ui/CLOSE_MODAL';
export const SET_MODAL = 'ui/SET_MODAL';
